






























































































import CheckBox from "@/components/basic/fields/CheckBox.vue";
import Field from "@/components/basic/fields/Field.vue";
import Radio from "@/components/basic/fields/Radio.vue";
import Error from "@/components/basic/Error.vue";
import PolandTaxResidenceField from "@/components/compositeFields/PolandTaxResidenceField.vue";
import Select from "@/components/basic/fields/Select.vue";
import TaxResidenceField from "@/components/compositeFields/TaxResidenceField.vue";
import TaxOfficeList from "@/components/compositeFields/TaxOfficeListField.vue";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import Vue from "vue";
import NoTinField from "@/components/compositeFields/NoTinField.vue";
import { DataObject, TaxOfficeDataInterface } from "@/types";
import { TaxResidenceFlags } from "@/constants/tax-residence-flags";
import { mapState } from "vuex";
import { SET_PROGRESS } from "@/constants/mutation-types";

export default Vue.extend({
  name: "TaxResidence",
  data() {
    return {
      TaxField,
      formData: {} as DataObject,
      taxOfficeDataForeigner: {},
      isOpenSecondTaxResidence: false,
      isOpenThirdTaxResidence: false,
      TRANSLATION_KEY: "steps.TaxResidence",
    };
  },
  mounted() {
    this.$store.commit(SET_PROGRESS, 5);
    
    if (this.taxResidenceData.secondTaxCountry && this.taxResidenceData.addSecondTaxCountry) {
      this.isOpenSecondTaxResidence = true;
    }
    if (this.taxResidenceData.thirdTaxCountry && this.taxResidenceData.addThirdTaxCountry) {
      this.isOpenThirdTaxResidence = true;
    }
    this.setFieldIfForeignerInPoland();
  },
  methods: {
    setFieldIfForeignerInPoland(): void {
      if (this.taxResidenceData.taxResidenceFlag === TaxResidenceFlags.FOREIGNER_LIVE_POLAND) {
        // set default tax office if customer is foreigner who lives in Poland and confirm that he has poland tax residence
        this.setDefaultTaxOfficeForeigner();
      }
    },
    setDefaultTaxOfficeForeigner(): void {
      this.taxOfficeDataForeigner = {
        key: defaultTaxOfficeForeigner.TAX_OFFICE_ID,
        value: defaultTaxOfficeForeigner.TAX_OFFICE_NAME,
      };
    },
    receiveData(name: TaxField, taxOfficeData: TaxOfficeDataInterface) {

      for (const entry in taxOfficeData) {
        if (taxOfficeData.hasOwnProperty(entry)) {
          const newName = entry.slice(0, 1).toUpperCase() + entry.slice(1, entry.length);
          this.formData[name + newName] = (taxOfficeData as DataObject)[entry];
        }
      }
      this.formData["add" + name.slice(0, 1).toUpperCase() + name.slice(1, name.length) + "TaxCountry"] = true;
    },
    handleTaxResidence(taxResidence: TaxField) {
      if (taxResidence === TaxField.SECOND_TAX_RESIDENCE) {
        if (!this.isOpenThirdTaxResidence) {
          this.isOpenSecondTaxResidence = !this.isOpenSecondTaxResidence;
        }
      } else {
        this.isOpenThirdTaxResidence = !this.isOpenThirdTaxResidence;
      }
      this.deleteData(taxResidence);
    },
    deleteData(name: TaxField) {
      for (const entry in this.formData) {
        if (this.formData.hasOwnProperty(entry)) {
          if (entry.startsWith(name)) {
            delete this.formData[entry];
          }
        }
      }
      delete this.formData["add" + name.slice(0, 1).toUpperCase() + name.slice(1, name.length) + "TaxCountry"];
    },
  },
  watch: {
    "isOpenSecondTaxResidence"(newValue, oldValue): void {
      this.formData.addSecondTaxCountry = newValue;
      //this.$refs.childRef.mergeFormData();
    },
  },
  components: {
    NoTinField,
    Error,
    CheckBox,
    Field,
    Radio,
    TaxOfficeList,
    Select,
    SubmitButton,
    TaxResidenceField,
    PolandTaxResidenceField,
  },
  computed: {
    ...mapState({
      countries: (state: any) => state.config.countries,
      taxResidenceData: (state: any): any => state.formData || {},
    }),
  },
});

enum defaultTaxOfficeForeigner {
  TAX_OFFICE_ID = 1076,
  TAX_OFFICE_NAME = "Trzeci Urząd Skarbowy Warszawa-Śródmieście - ul. Lindleya 14, 02-013",
}

enum TaxField {
  FIRST_TAX_RESIDENCE = "first",
  SECOND_TAX_RESIDENCE = "second",
  THIRD_TAX_RESIDENCE = "third",
}
